/* jshint unused: false */
/* eslint no-unused-vars: 0 */
angular.module('services').service('FakeLightbox', ($rootScope, $window, $timeout) => {

    function updateFakeLightbox(state) {

        $timeout(() => {

            $rootScope.FakeLightbox.active = state;

        }, 0);

    }

    const OE = {
        ltx: {
            open: () => {

                updateFakeLightbox(true);

            },
            close: () => {

                updateFakeLightbox(false);

            },
        },
    };

    $window.OE = OE;

})
    /* Autorun service */
    .run(($rootScope, FakeLightbox) => {

        $rootScope.FakeLightbox = {
            active: 0,
        };

    });



// WEBPACK FOOTER //
// ./scripts/services/fakeLightbox.js